export function splitSlots<A, B, C, D, E>({
  slots,
  lists: [A, B, C, D, E],
}: {
  slots: number;
  lists: readonly [readonly A[], readonly B[], readonly C[], readonly D[], readonly E[]];
}): readonly [A[], B[], C[], D[], E[]] {
  const a: A[] = [];
  const b: B[] = [];
  const c: C[] = [];
  const d: D[] = [];
  const e: E[] = [];

  const result = [a, b, c, d, e] as const;

  if (!A.length && !B.length && !C.length && !D.length && !E.length) return result;

  const aDup = A.slice(0);
  const bDup = B.slice(0);
  const cDup = C.slice(0);
  const dDup = D.slice(0);
  const eDup = E.slice(0);

  let slotsLeft = slots;

  function takeSlot(cb: () => void) {
    if (slotsLeft) {
      slotsLeft--;
      cb();
    }
  }

  while (slotsLeft) {
    const startSlots = slotsLeft;
    const [aValue, bValue, cValue, dValue, eValue] = [
      aDup.shift(),
      bDup.shift(),
      cDup.shift(),
      dDup.shift(),
      eDup.shift(),
    ];

    aValue !== undefined && takeSlot(() => a.push(aValue));
    bValue !== undefined && takeSlot(() => b.push(bValue));
    cValue !== undefined && takeSlot(() => c.push(cValue));
    dValue !== undefined && takeSlot(() => d.push(dValue));
    eValue !== undefined && takeSlot(() => e.push(eValue));

    if (startSlots === slotsLeft) return result;
  }

  return result;
}
